import {Autocomplete, TextField} from "@mui/material";
import { useEffect, useState } from 'react';

const MySearchSelect = (props) => {

  const {options, label, id, readOnly, defaultValue, value, inputMaxLength, handleChange, handleSearchChange, disabled} = props;

  return (<Autocomplete
    disablePortal
    id={id}
    readOnly={readOnly === true}
    options={options}
    defaultValue={defaultValue ? defaultValue : null}
    onChange = {handleChange ? handleChange : null }
    sx={{width: 300}}
    renderInput={(params) => <TextField type={"text"} onChange={handleSearchChange} maxLength={inputMaxLength} {...params} label={label}/>}
    value={value}
    disabled={disabled}
  />);
}

export default MySearchSelect;